import * as React from "react";
import { Query } from "react-apollo";
import { USER_QUERY } from "./queries";
import {
  UserByIdQuery,
  UserByIdQueryVariables
} from "../../__generated__/types";
import UserDetails from "../../components/UserDetails";

class GetUserByIdQuery extends Query<UserByIdQuery, UserByIdQueryVariables> {}

export interface Props {
  match: {
    params: {
      userId: string | null;
    };
  };
}

export default (props: Props) => {
  const id = props.match.params.userId;
  if (id) {
    return (
      <GetUserByIdQuery query={USER_QUERY} variables={{ id: id }}>
        {({ loading, error, data }) => {
          if (!data) {
            return null;
          }
          if (error) {
            return <h1>ERROR</h1>;
          }
          return (
            <UserDetails admin={true} user={data.user} loading={loading} />
          );
        }}
      </GetUserByIdQuery>
    );
  } else {
    return <UserDetails admin={true} add={true} user={null} />;
  }
};



// WEBPACK FOOTER //
// ./src/screens/User/UserPage.tsx